@if (!showMarquee) {
    @for (promotion of promotions; track promotion.id; let position = $index) {
        <ms-crm-promotion-banner [promotion]="promotion" [listIndex]="position" [trackingSource]="trackingSource" />
    }
}
@if (showMarquee) {
    <ng-container *msComponentProxy="marqueeComponent" />
}
